module.exports = __webpack_public_path__ + "static/yellow-footer-shape-adf583a03409ca41e905d456d1ee3106.png";